import { Component, Input, OnChanges, OnInit, SimpleChanges,ElementRef,ViewChild,ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { PetService } from '../../../services/pet.service';
import { CatalogService } from '../../../services/catalog.service';
import { PetTagHistModel } from '../../../models/pet-tag-hist.model';
import Swal from 'sweetalert2';

declare var $: any;

@Component({
  selector: 'ngx-work-pet-info',
  templateUrl: './pet-info.component.html',
})
export class PetInfoComponent implements OnInit {
  @ViewChild('selectElement') selectElement: ElementRef;

  private _pet_no: number;
  pet_codes = ['','','','','','','','','','']; 
  selectedCode: string;

  @Input() set pet_no(value: number) {
    this._pet_no = value;
  }

  get pet_no(): number {
    return this._pet_no;
  } 

  constructor(
    public petService: PetService,
    public catalogService: CatalogService,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef
  ) {
  }

  ngOnInit() { 
    this.petService.changePet
      .subscribe(message => {
        this.pet_no = message;
        //this.assign_code();
        this.initCodes()
        this.petService.pet.active = this.petService.pet.deceased === true ? 'D' : this.petService.pet.active;
      }); 

    this.catalogService.getPetCode().then(() => {})
  }

  initCodes(){
    let origString = this.petService.pet.pet_code.split('');
    for (let index = 0; index < origString.length; index++) {
      this.pet_codes[index] = origString[index];
    }
  }

  assign_code() {
    // $('#_code1').val('');
    // $('#_code2').val('');
    // $('#_code3').val('');
    // $('#_code4').val('');
    // debugger;

    this.petService.pet.codes = [];
    let origString = this.petService.pet.pet_code.split('');

    if (origString && origString.length > 0) {
      for (let index = 0; index < origString.length; index++) {
        $(`#_code${index}`).val('');
      }

      for (let index = 0; index < origString.length; index++) {
        this.petService.pet.codes.push(origString[index]);
        $(`#_code${index}`).val(origString[index]);

        // this.petService.pet[`code${index + 1}`] = origString[index];
        // $(`#_code${index + 1}`).val(origString[index]);
      }

      switch (this.petService.pet.codes.length) {
        case 1:
          this.petService.pet.codes.push('');
          this.petService.pet.codes.push('');
          this.petService.pet.codes.push('');
          break;

        case 2:
          this.petService.pet.codes.push('');
          this.petService.pet.codes.push('');
          break;

        case 3:
          this.petService.pet.codes.push('');
          break;
      }

      setTimeout(() => {
        for (let index = 0; index < this.petService.pet.codes.length; index++) {
          $(`#_code${index}`).val('');
        }

        for (let index = 0; index < origString.length; index++) {
          $(`#_code${index}`).val(origString[index]);
        }
      }, 150);
    }
  }

  get petStatus(): string {
    return this.petService.pet.deceased === true ? 'D' : this.petService.pet.active === 'N' ? 'Inactive' : 'Active';
  }

  save() {
    Swal.fire({
      title: 'Loading...',
      timerProgressBar: true,
      didOpen: () => {
        Swal.showLoading()
      },
    })

    const concatenatedCode = this.pet_codes.filter(code => code !== '').join(''); 
    this.petService.pet.pet_code = concatenatedCode


    this.petService.pet.deceased = this.petService.pet.active === 'D' ? true : false;
    this.petService.pet.active = this.petService.pet.active === 'D' ? 'N' : this.petService.pet.active;

    this.petService.setupPetInfo()
      .then(() => {
        Swal.close();

        Swal.fire({
          title: 'Information stored correctly',
          didOpen: () => {
            this.petService.GetPetProfileLastEntry(this.petService.current_pet_no).then(() => { });
            this.petService.notifyPetUpdatedFunction();
          },
        })
      });
  }

  frecalculate() {
    let today = new Date();
    let fields = this.petService.pet.dob.split('-');
    let finish = new Date(Number(fields[0]), Number(fields[1]) - 1, Number(fields[2]), today.getHours(), today.getMinutes(), today.getSeconds());
    let Difference_In_Time = today.getTime() - finish.getTime();
    var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
    var Difference_In_Years = Difference_In_Days / 365;

    if (Difference_In_Years < 0) {
      Swal.fire({
        title: 'Date cannot be more than today!',
        didOpen: () => {
        },
      })
      this.petService.pet.age = 0;
      this.petService.pet.dob = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;
      return;
    }

    this.petService.pet.age = Math.abs(Math.round(Difference_In_Years));
  }

  ccode(indexPosition) {

    let mayor = false;
    let code = $(`#_code${indexPosition}`).val();

    if (this.petService.pet.pet_code.includes(code)) {
      Swal.fire({
        title: 'Cannot add code, it is duplicated!',
        didOpen: () => {
        },
      })
      $(`#_code${indexPosition}`).val('');
      return;
    }

    let origString = this.petService.pet.pet_code.split('');

    if (indexPosition + 1 > origString.length) {
      mayor = true
    }

    if (code === '') {
      origString.splice(indexPosition, 1)
    } else {
      origString.splice(indexPosition, 0, code);
    }

    this.petService.pet.pet_code = origString.join('');

    if (mayor) {
      $(`#_code${indexPosition}`).val('');
    }

    this.assign_code();
  }
 
  add() {  
    if(this.petService.pet.codes == undefined){
      this.petService.pet.codes = [];
    }
    console.log(this.petService.pet.codes);
    if (this.petService.pet.codes.length > 10) {
      Swal.fire({
        title: 'Only 10 codes are available',
        didOpen: () => {
        },
      })
      return;
    }
    this.petService.pet.codes.push('');
  }

  viewDetailCode(item) {
    if (this.catalogService.pet_code.some(t => t.code === item))
      return this.catalogService.pet_code.find(t => t.code === item).name;
    else
      return '';
  }

  addCodes() { 
    this.pet_codes.push('');
  }

  sample() {
    const concatenatedString = this.pet_codes.filter(code => code !== '').join(''); 
    console.log(concatenatedString); 
  }

  onCodeChange(code: string, index: number) {
    this.pet_codes[index] = code;
  }

  areAllCodesFilled(): boolean {
    return this.pet_codes.every(code => code.trim() !== '');
  }

  onStatusChange(status: string) {
    if(status == 'D' || status == 'N'){
      this.petService.GetLastPetTagbyPetNo(this.pet_no).then((item: PetTagHistModel) => {
        console.log(item);
        if (item.status == 'A') {
           Swal.fire({
            title: 'Pet has a TAG No.',
            text: 'Do you want to REMOVE the tag number?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
           }).then((result) => {
            if (result.isConfirmed) {
                this.petService.SetupTagNo(item.id, item.tag_no, this.pet_no, this.petService.pet.pet_name, item.location, item.sublocation, item.duration, item.assign_date, 'C', item.department).then(() => {
                  Swal.fire({title: 'Tag number removed successfully'})
                }).catch((err) => {
                  const msg = err?.error?.message || err?.message || 'Unable to assign tag.';
                  Swal.fire('Tag assignment failed', msg, 'error');
                });
              }
           })
        }
      })
    }
  }
}
